import { render } from "./perfilForm.vue?vue&type=template&id=cbe3ae3c&scoped=true"
import script from "./perfilForm.vue?vue&type=script&lang=js"
export * from "./perfilForm.vue?vue&type=script&lang=js"

import "./perfilForm.vue?vue&type=style&index=0&id=cbe3ae3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe3ae3c"]])

export default __exports__